export default __webpack_public_path__ + "static/media/logo-legis-branco.9801a220.svg";